import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { Question } from 'src/app/models/question.model';
import { DisplayByTypeDirective } from '../../../question/display-by-type.directive';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { SvgIconComponent } from 'angular-svg-icon';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { EQuestionAction } from 'src/app/models/EnumQuestionAction';
import { DragStore } from 'src/app/store/drag-store';

@Component({
    selector: 'que-menu-question',
    imports: [CommonModule, MatMenuModule, TranslateDirective, TranslatePipe, MatButtonModule, DisplayByTypeDirective, OverlayModule],
    templateUrl: './menu-question.component.html',
    styleUrls: ['./menu-question.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuQuestionComponent {
  @Input()
  question?: Question | null;
  // @Input()
  // isAutocomplete = false;
  // @Input()
  // collectionQuestionId?:number| null;
  // [isRequierd]="questionForm.value?.requierd"
  // [collectionQuestionId]="questionForm.value?.collectionQuestionId"
  #questionnaireStore = inject(QuestionnaireStore);
  #dragStore = inject(DragStore)
  apiExposureEnabled$ = toSignal(this.#questionnaireStore.apiExposureEnabled$);
  isUnauthorized$ = toSignal(this.#questionnaireStore.isUnauthorized$);
  isFilterField$ = toSignal(this.#questionnaireStore.filterFieldId$);
  @Output() eventMenu = new EventEmitter<EQuestionAction>();
  @Output() focus = new EventEmitter<boolean>();
  isMenuOpen = false;

  readonly positonArea = [{
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
  }] as ConnectedPosition[];


  delete() {
    this.eventMenu.emit(EQuestionAction.delete);
  }
  requierd() {
    this.eventMenu.emit(EQuestionAction.requierd);
  }
  saveList() {
    this.isMenuOpen = false;
    this.eventMenu.emit(EQuestionAction.saveList);
  }
  addToCollection() {
    this.isMenuOpen = false;
    if (this.question?.type.id != 24)
      this.eventMenu.emit(EQuestionAction.addToCollection);
  }

  addToApiExposureCollectionFields() {
    this.isMenuOpen = false;
    this.eventMenu.emit(EQuestionAction.addToApiExposureCollectionFields);
  }
  editToApiExposureCollectionFields() {
    this.isMenuOpen = false;
    this.eventMenu.emit(EQuestionAction.editToApiExposureCollectionFields);
  }
  chooseAsFilterField() {
    this.isMenuOpen = false;
    this.eventMenu.emit(EQuestionAction.chooseAsFilterField);
  }
   chooseAsAutoFillField() {
    this.isMenuOpen = false;
    this.eventMenu.emit(EQuestionAction.chooseAsAutoFillField);
  }
  editAsAutoFillField() {
    this.isMenuOpen = false;
    this.eventMenu.emit(EQuestionAction.editAsAutoFillField);
  }
  removeAsAutoFillField() {
    this.isMenuOpen = false;
    this.eventMenu.emit(EQuestionAction.removeAsAutoFillField);
  }
  removeAsFilterField() {
    this.isMenuOpen = false;
    this.eventMenu.emit(EQuestionAction.removeAsFilterField);
  }
  // canBeFilterField(question: Question | null | undefined): boolean {
  //   const filterableTypes = [1, 2, 3, 4, 5, 6, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
  //   console.log('question', question)
  //   return question ? filterableTypes.includes(question.type.id) : false;
  // }
}
